import * as yup from 'yup';

const termsAndConditionsSchema = yup.object({
  accepted: yup.boolean().required()
});

export type TermsAndConditions = yup.InferType<typeof termsAndConditionsSchema>;

export default termsAndConditionsSchema;
